<template>
  <footer class="footer" :style="footerStyle">
    <div class="footer-inner">
      <div class="footer-left">
        <h3 class="footer-heading">Join our waitlist</h3>
        <div class="email-input-wrap">
          <input
            type="email"
            v-model="email"
            placeholder="E-mail"
            class="email-input"
            @keyup.enter="submitEmail"
          />
          <button class="email-submit" :disabled="submitting" @click="submitEmail">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
        <p v-if="tip" class="footer-tip" :class="{ ok: tipOk }">{{ tip }}</p>
      </div>
      <div class="footer-right">
        <div class="footer-col">
          <h4>Support</h4>
          <ul>
            <li>Contact</li>
            <li>Support</li>
            <li>Feedback</li>
          </ul>
        </div>
        <div class="footer-col">
          <h4>Legal</h4>
          <ul>
            <li>Refund Policy</li>
            <li>Privacy Policy</li>
            <li>Terms of Service</li>
            <li>Legal Notice</li>
          </ul>
        </div>
        <div class="footer-col">
          <h4>Quick Finds</h4>
          <ul>
            <li>iBuzzPen</li>
            <li>Support</li>
            <li>Invest</li>
            <li>FAQs</li>
          </ul>
        </div>
        <div class="footer-col">
          <h4>The iBuzzPen Future</h4>
          <p class="footer-feature-desc">
            The pen body is equipped with an advanced high-speed camera, which captures every subtle detail during the writing process in real time.
          </p>
          <p class="footer-feature-desc">
            The pen body is equipped with an advanced high-speed camera, which captures every subtle detail during the writing process in real time.
          </p>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-left">
        <div class="social-icons">
          <img class="social-icon" src="@/assets/footer/wx-icon.png" alt="WeChat" />
          <img class="social-icon" src="@/assets/footer/xhs-icon.png" alt="RED" />
          <img class="social-icon" src="@/assets/footer/dy-icon.png" alt="TikTok" />
        </div>
        <p class="copyright">&copy; copyright 2025, iBuzzPen, Inc</p>
      </div>
      <div class="badge-row">
        <!-- <img class="badge-strip" src="@/assets/footer/badge-row.png" alt="Payment methods" /> -->
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AppFooter',
  props: {
    horizontalPadding: {
      type: String,
      default: 'clamp(20px, 8.44vw, 162px)'
    }
  },
  data() {
    return {
      email: '',
      submitting: false,
      tip: '',
      tipOk: false
    }
  },
  computed: {
    footerStyle() {
      return {
        paddingLeft: this.horizontalPadding,
        paddingRight: this.horizontalPadding
      }
    }
  },
  methods: {
    async submitEmail() {
      if (this.submitting) return
      if (!this.email) {
        this.tipOk = false
        this.tip = 'Please enter your email.'
        return
      }
      if (!/^[a-zA-Z0-9_\-+.]+@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)+$/.test(this.email)) {
        this.tipOk = false
        this.tip = 'Invalid email format.'
        return
      }
      this.submitting = true
      this.tip = ''

      const params = {
        joinMail: this.email,
        joinType: '1'
      }
      try {
        await axios.post(`${this.BaseUrl}/api/ana/submitFeedback`, params)
        this.tipOk = true
        this.tip = 'Subscribed successfully. Thank you!'
        this.email = ''
      } catch (e) {
        this.tipOk = false
        this.tip = 'Submission failed, please try again later.'
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$container-max: 1760px;

.footer {
  background: #ffffff;
  padding-top: 60px;
  padding-bottom: 30px;
  color: #333;

  .footer-inner {
    max-width: $container-max;
    margin: 0 auto;
    display: flex;
    gap: 50px;
    justify-content: space-between;
  }

  .footer-left {
    flex: 0 0 300px;
  }

  .footer-heading {
    font-size: clamp(22px, 2vw, 28px);
    font-weight: 700;
    color: #222;
    margin: 0 0 24px;
  }

  .email-input-wrap {
    position: relative;
    width: 100%;
    margin-bottom: 40px;

    .email-input {
      width: 100%;
      padding: 12px 44px 12px 16px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      font-size: 15px;
      outline: none;
      box-sizing: border-box;
      background: #fff;

      &:focus { border-color: #999; }
    }

    .email-submit {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #f0f0f0;
      border: none;
      cursor: pointer;
      color: #999;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;

      &:hover { background: #e4e4e4; }
      &:disabled { opacity: 0.5; cursor: not-allowed; }
    }
  }

  .footer-tip {
    margin: -28px 0 20px;
    font-size: 13px;
    color: #e6435f;

    &.ok { color: #10aa32; }
  }

  .social-icons {
    display: flex;
    gap: 16px;
    align-items: center;
    // 图标底部距版权文字 50px
    margin-bottom: 50px;

    .social-icon {
      width: 20px;
      height: 20px;
      object-fit: contain;
      cursor: pointer;
      display: block;
    }
  }

  .copyright {
    font-size: 12px;
    color: #999;
    margin: 0;
  }

  .footer-right {
    // flex: 1;
    display: flex;
    gap: 40px;
  }

  .footer-col {
    max-width: 340px;
    // flex: 1;

    &:last-child {
      // flex: 2;
    }

    h4 {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin: 0 0 16px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        font-size: 14px;
        color: #999;
        margin-bottom: 10px;
        cursor: pointer;
        transition: color 0.2s;

        &:hover { color: #333; }
      }
    }

    .footer-feature-desc {
      font-size: 14px;
      color: #bbb;
      line-height: 1.7;
      margin: 0 0 16px;
    }
  }

  .footer-bottom {
    max-width: $container-max;
    margin: 37px auto 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    // 设计稿中徽章行比右侧链接列更靠右(右留白约 60px)
    margin-right: calc(60px - clamp(20px, 8.44vw, 162px));

    .footer-bottom-left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .badge-row {
      display: flex;
      align-items: center;

      .badge-strip {
        display: block;
        width: 480px;
        max-width: 100%;
        height: auto;
      }
    }
  }
}

// ========== Responsive: Tablet ==========
@media (max-width: 1024px) {
  .footer {
    .footer-inner {
      gap: 40px;
      flex-wrap: wrap;
    }
    .footer-left { flex: 0 0 100%; }
    .footer-right {
      flex: 1 1 100%;
      gap: 30px;
      flex-wrap: wrap;
    }
    .footer-col {
      flex: 1 1 calc(50% - 15px);
      min-width: 140px;
    }
  }
}

// ========== Responsive: Mobile ==========
@media (max-width: 768px) {
  .footer {
    .footer-inner { gap: 32px; }
    .footer-right { gap: 24px; }
    .footer-col { flex: 1 1 100%; }
    .footer-bottom {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      margin-top: 24px;
      margin-right: 0;
    }
    .email-input-wrap { margin-bottom: 28px; }
  }
}
</style>
